// extracted by mini-css-extract-plugin
export default {"malfunction":"MalfunctionGraphic_malfunction__RdCwb","inner":"MalfunctionGraphic_inner__uuoFR","info":"MalfunctionGraphic_info__DrhZ3","card":"MalfunctionGraphic_card__qgCh-"};